/** 装饰性QR占位（非可扫真码）；中心为Astra星标。 */
export function QrPlaceholder() {
  const N = 21;
  const S = 8;
  const seed = (x: number, y: number) => ((x * 31 + y * 17 + 7) % 11) > 5;

  const isFinderRing = (x: number, y: number) => {
    if (x < 7 && y < 7) {
      return (
        x === 0 ||
        x === 6 ||
        y === 0 ||
        y === 6 ||
        (x >= 2 && x <= 4 && y >= 2 && y <= 4)
      );
    }
    if (x > N - 8 && y < 7) {
      const xx = x - (N - 7);
      return (
        xx === 0 ||
        xx === 6 ||
        y === 0 ||
        y === 6 ||
        (xx >= 2 && xx <= 4 && y >= 2 && y <= 4)
      );
    }
    if (x < 7 && y > N - 8) {
      const yy = y - (N - 7);
      return (
        x === 0 ||
        x === 6 ||
        yy === 0 ||
        yy === 6 ||
        (x >= 2 && x <= 4 && yy >= 2 && yy <= 4)
      );
    }
    return false;
  };

  const isFinder = (x: number, y: number) =>
    (x < 7 && y < 7) || (x > N - 8 && y < 7) || (x < 7 && y > N - 8);

  const cells: { x: number; y: number }[] = [];
  for (let y = 0; y < N; y++) {
    for (let x = 0; x < N; x++) {
      const on = isFinder(x, y) ? isFinderRing(x, y) : seed(x, y);
      if (on) cells.push({ x, y });
    }
  }

  return (
    <div className="relative mx-auto h-[232px] w-[232px]">
      <span className="absolute left-3 top-3 h-4 w-4 border-l-[1.5px] border-t-[1.5px] border-forest-900" />
      <span className="absolute right-3 top-3 h-4 w-4 border-r-[1.5px] border-t-[1.5px] border-forest-900" />
      <span className="absolute bottom-3 left-3 h-4 w-4 border-b-[1.5px] border-l-[1.5px] border-forest-900" />
      <span className="absolute bottom-3 right-3 h-4 w-4 border-b-[1.5px] border-r-[1.5px] border-forest-900" />

      <div className="flex h-full w-full items-center justify-center rounded-[20px] border border-[var(--line)] bg-paper">
        <div className="relative">
          <svg width={N * S} height={N * S} viewBox={`0 0 ${N * S} ${N * S}`} aria-hidden>
            {cells.map((c) => (
              <rect
                key={`${c.x}-${c.y}`}
                x={c.x * S}
                y={c.y * S}
                width={S}
                height={S}
                fill="#16171A"
              />
            ))}
          </svg>
          <div className="absolute left-1/2 top-1/2 flex h-9 w-9 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-lg border-[1.5px] border-forest-900 bg-paper">
            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" aria-hidden>
              <path
                d="M7 0.5L7.9 5.1L12.5 6L7.9 6.9L7 11.5L6.1 6.9L1.5 6L6.1 5.1L7 0.5Z"
                fill="#155B47"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
